var validation = require('src/interlock/no-ui/validation/common/index');
var parseError = require('./error-parser');

var validators = {
    firstName: {test: validation.validateMinLength, errorText: 'First name can not be empty', minLength: 0},
    lastName: {test: validation.validateMinLength, errorText: 'Last name can not be empty', minLength: 0},
    email: {test: validation.validateEmail, errorText: 'Please enter your correct email address'},
    password: {test: validation.validateMinLength, errorText: 'Your password must be more than 6 characters long', minLength: 6},
    passwordConfirm : {test: validation.shouldMatch, errorText: 'Passwords do not match', shouldMatch: 'password'}
};

function validateField(form, input, errorBlock) {
    $(errorBlock).empty();
    var validator = validators[input.name];

    if (validator.shouldMatch) {
        var shouldMatchValue = $('input[name="' + validator.shouldMatch + '"]').val();
    }

    validator.test(input.value, validator.minLength, shouldMatchValue).done(function(result) {
        if (!result) {
            $(errorBlock).append('<li>' + validator.errorText + '</li>');
            highlightError(form.find('input[name="' + input.name + '"]'));
        } else {
            highlightSuccess(form.find('input[name="' + input.name + '"]'));
        }
    });
}

function isFormValid(form) {
    return form.find('.has-danger').length === 0;
}

function highlightError(element) {
    $(element).removeClass('form-control-success').addClass('form-control-danger')
              .parent().removeClass('has-success').addClass('has-danger');
}

function highlightSuccess(element) {
    $(element).removeClass('form-control-danger').addClass('form-control-success')
              .parent().removeClass('has-danger').addClass('has-success');
}

module.exports = {
    validateField: validateField,
    isFormValid: isFormValid,
    parseFirebaseError: parseError
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/profile/validation.js
// module id = 5
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14